import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiResponse } from '../../shared/models';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';
import { DisposalType } from '../models';

@Injectable()
export class DisposalTypesService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  getDisposalType(iri: string): Observable<DisposalType> {
    return this.rolesService.userHasRoleFilter<DisposalType>(
      'ROLE_MWS_DISPOSAL_TYPE_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  getDisposalTypes(): Observable<AbstractApiResponse | any> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_DISPOSAL_TYPE_LIST',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(`/disposal_types`)
    );
  }
}
